import { ReactNode } from 'react';
import { useResolveController, withNewContainer } from '@visiba/instantiation';
import { MyAccountController } from './my_account.controller';
import { Scenario } from './scenario.service';

type MyAccountRootProps = {
	children: ReactNode;
};

export const MyAccountRoot = withNewContainer(function MyAccountRoot({ children }: MyAccountRootProps) {
	useResolveController(MyAccountController);

	return <Scenario.Root>{children}</Scenario.Root>;
});
